import { Component } from "@angular/core";
import { AbstractPopupDialogDirective } from "../_shared/abstract/abstract-popup-dialog.directive";
import { PopupDialogConfig } from "../_shared/popup.model";
import { UserService } from "@services";
import { PopupService } from "@core";

@Component({
  selector: "app-popup-page-dialog-variant-locked",
  templateUrl: "./popup-dialog-variant-locked.component.html",
  styleUrls: ["./popup-dialog-variant-locked.component.scss"],
})
export class PopupDialogVariantLockedComponent extends AbstractPopupDialogDirective {
  currentStep = 1;
  stepsCount = 1;

  private _configOverwrite: Partial<PopupDialogConfig> = {
    closeOnBackgroundClick: true,
  };

  onClose(): void {}

  constructor(
    protected override _popupService: PopupService,
    private _userService: UserService,
  ) {
    super(_popupService);
    this.config = { ...this.config, ...this._configOverwrite };
  }
}
